import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from 'utils';

export const acceptInvitationStart = createAction(
  'ACCEPT_INVITATION::START',
  withPayloadType<{ id: string; organizationId: string }>(),
);
